// extracted by mini-css-extract-plugin
export default {"root":"zdFJhjpFHo","root_fill":"M5XbymLrji"};